import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAPetCare() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ petCare, setPetCare ] = useState(powerOfAttorney.pet_care || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../personal-family-care');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      pet_care: petCare
    }));
    navigate('../government-benefits');
  }, [ petCare, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-pet-care screen-container screen">
      <ScreenHeader
        title="Pet Care"
        description="Decide whether to grant your agent power to care for your pets"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Pet Care Powers?</h3>
        <p>
          Pet care powers allow your agent to make decisions and arrangements 
          for the care of your pets and animals. This includes:
        </p>
        <ul className="pet-care-list">
          <li>Arranging daily care and feeding</li>
          <li>Hiring pet sitters or boarding services</li>
          <li>Making veterinary decisions and payments</li>
          <li>Finding permanent homes if needed</li>
          <li>Managing pet insurance and medical care</li>
          <li>Handling pet-related expenses</li>
          <li>Making end-of-life decisions for pets</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Authorize veterinary care and treatment</li>
          <li>Arrange temporary or permanent care</li>
          <li>Spend money on pet care and expenses</li>
          <li>Make decisions about pet housing</li>
          <li>Handle pet emergencies</li>
          <li>Work with veterinarians and pet services</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="pet-care-yes"
            label="Yes"
            description="Grant power to care for my pets"
            value="yes"
          />
          <AssetDistributionOption
            id="pet-care-no"
            label="No"
            description="Do not grant power to care for my pets"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Consider discussing your wishes for pet care with your agent and perhaps 
            creating a separate pet care plan that outlines your preferences for 
            your pets' care and any funds set aside for this purpose.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
